export const ZOOM_STEP = 10;
export const MIN_ZOOM = 50;
export const MAX_ZOOM = 200;

export const nextZoom = (current: number, step: number) =>
  Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, current + step));
